import { render, staticRenderFns } from "./EditTagLoader.vue?vue&type=template&id=6286a4f6"
import script from "./EditTagLoader.vue?vue&type=script&lang=ts"
export * from "./EditTagLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports